"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var I18n = require("i18n-js");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var classNames = require("classnames");
var EmailSignUpEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(EmailSignUpEmbed, _super);
    function EmailSignUpEmbed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            signedUp: false,
        };
        _this.onSubmit = function () {
            _this.setState({ signedUp: true });
        };
        return _this;
    }
    EmailSignUpEmbed.prototype.render = function () {
        return (React.createElement("section", { className: classNames('align-center mt-2', {
                'article-email-signup': !this.props.hideBg,
            }) },
            React.createElement("h3", { className: "article-email-signup__heading" }, this.props.callout),
            React.createElement("form", { action: "/mailchimp_subscriptions?list_id=" + this.props.listId, onSubmit: this.onSubmit, method: "post" },
                React.createElement("input", { type: "hidden", name: "signup_reason", value: this.props.reason }),
                React.createElement("div", { className: "g-container" },
                    React.createElement("div", { className: "g-col-5 g-offset-2 g-col-mobile-12 g-offset-mobile-0 mobile-pb-1" },
                        React.createElement("input", { className: "article-email-signup__email-input", type: "email", name: "email", placeholder: "Your email", defaultValue: lodash_1.get(this, 'props.user.email'), required: true })),
                    React.createElement("div", { className: "g-col-3 g-col-mobile-12" },
                        React.createElement("input", { className: "wide btn btn-primary", type: "submit", value: I18n.t('discovery.emailEmbed.subscribe'), name: "subscribe" }))),
                React.createElement("div", { className: "g-container" },
                    React.createElement("div", { className: "g-col-7 g-offset-2 g-col-mobile-12" },
                        React.createElement("div", { className: "position-relative" }, this.state.signedUp && (React.createElement("div", { className: "overlay alert alert-small alert-success" }, this.props.success))))))));
    };
    return EmailSignUpEmbed;
}(React.Component));
exports.EmailSignUpEmbed = EmailSignUpEmbed;
exports.default = user_context_provider_1.withUserContext(EmailSignUpEmbed);
//# sourceMappingURL=email_signup_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/email_signup_embed.js
// module id = iH0z
// module chunks = 20 21